import {
  DeviceNode,
  QueryNode,
  ReportConfigNodes,
} from "../types/types";


export function exportQueryDataFromNodes(
  nodes: Array<DeviceNode> | Array<ReportConfigNodes>,
): Array<QueryNode> {
  // Only needed data for proper node data info gathering is
  // InstallationNodes.id and sensor types.
  // Creating a get param like: [{types: ["HUM",...], id: 3911}, ...]
  // Filtering out entries where no sensor `types` are actively selected

  const queryNodes: Array<QueryNode> = nodes
    .map((node) => {
      const item: QueryNode = { types: [], id: node.id };
      node.fields.forEach((sensor) => {
        if (sensor.enabled) {
          item.types.push(sensor.sens_type);
        }
      });
      return item;
    })
    .filter((el) => el.types.length > 0);
  return queryNodes;
}

export function filterQueryDataByChartlines(
  qd: QueryNode[],
  distinct_chart_lines: ReadonlySet<string>,
): QueryNode[] {
  let filtered: QueryNode[] = [];
  for (const node of qd) {
    // Drop any types that already seen in `distinct_chart_lines` set
    const filtered_types = node.types.filter((type) =>
      !distinct_chart_lines.has(`${type}_${node.id}`)
    )
    // Keep the entry if non-zero types remain
    if (filtered_types.length > 0) {
      filtered.push({id: node.id, types: filtered_types})
    }
  }
  return filtered
}
